import { showToast } from "Source/globalFunction";

export const copyToClipboard = (value, showToastFlag = true) => {
    navigator.clipboard.writeText(value)
    .then(() => { 
        if (showToastFlag) {
            showToast("success", "Copied to clipboard");
        }
    })
    .catch((error) => { 
        console.log(`Copy failed! ${error}`) 
    });
}